import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Logo from '../../assets/login/Logo.svg';
import './login.css';
import { toast } from 'react-toastify';
import { initializePusher } from '../../config/pusher';

const Login = () => {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const initialValues = {
    username: '',
    password: '',
    rememberMe: false,
  };

  const validationSchema = Yup.object({
    username: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .required('Password is required'),
  });
  useEffect(() => {

    if (user && user.role === "admin") {
      navigate('/admin/dashboard');
    }
    if (user && user.role === "staff") {
      navigate('/staff/dashboard');
    }
    if (user && user.role === "manager") {
      navigate('/manager/dashboard');
    }


  }, [user]);

  const handleSubmit = async (values) => {
    setError('');
    setIsLoading(true);

    try {
      const user = await login(values.username, values.password);
      console.log("askjd", user)

      toast.success("Login Successfully!")
      // initializePusher("","",user.token,user.privateChat)
      if (user.role === 'admin') {
        navigate('/admin/dashboard');
      } else if (user.role === 'staff') {
        navigate('/staff/dashboard');
      } else if (user.role === 'manager') {
        navigate('/manager/dashboard');
      } else {
        navigate('/');
      }
    } catch (err) {
      // setError(err.message || 'Failed to login');
      console.log("ajsdfk", err)
      toast.error(err.message)
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login_box container ">
      <div className="row align-items-center">
        <div className="col-md-7">
          <div className="login-left_image text"></div>
        </div>
        <div className="col-md-5">
          <div className="login-form" style={{ padding: '70px 30px 50px 30px' }}>
            <div className="text-center">
              <img src={Logo} className="login_logo text-center" alt="Logo" />
              <h1>Login</h1>
            </div>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  {/* Email Field */}
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">
                      Email
                    </label>
                    <Field
                      type="email"
                      className="form-control"
                      id="username"
                      name="username"
                      placeholder="Email address"
                    />
                    <ErrorMessage
                      name="username"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  {/* Password Field */}
                  <div className="mb-3 position-relative">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <div className="input-group">
                      <Field
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        id="password"
                        name="password"
                        placeholder="Type your password"
                      />
                      <span
                        className="input-group-text"
                        style={{ cursor: "pointer" }}
                        onClick={togglePassword}
                      >
                        <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}></i>
                      </span>
                    </div>
                    <ErrorMessage
                      name="password"
                      component="div"
                      className="text-danger"
                    />
                  </div>

                  {/* Remember Me */}
                  <div className="mb-3 form-check">
                    <Field
                      type="checkbox"
                      className="form-check-input"
                      id="rememberMe"
                      name="rememberMe"
                    />
                    <label className="form-check-label" htmlFor="rememberMe">
                      Remember me
                    </label>
                  </div>

                  {/* Login Button */}
                  <button
                    type="submit"
                    className="btn btn-custom w-100"
                    disabled={isLoading || isSubmitting}
                    style={{ color: 'white' }}
                  >
                    {isLoading ? 'Logging in...' : 'Login'}
                  </button>
                </Form>
              )}
            </Formik>
            <div style={{ marginTop: '35px', textAlign: 'center' }}>
              <div style={{ color: '#5c4b3b', fontWeight: 500,margin:'10px 0px' }}>
                Don’t have an account?
              </div>
              <div style={{ color: '#5c4b3b', fontWeight: 500 }}>
                <Link
                  to="/register-as-manager"
                  style={{
                    textDecoration: 'none',
                    color: '#5c4b3b',
                    borderBottom: '1px solid transparent',
                    transition: 'all 0.3s ease',
                    marginRight: '8px',
                  }}
                  onMouseEnter={(e) => (e.target.style.borderBottom = '1px solid #5c4b3b')}
                  onMouseLeave={(e) => (e.target.style.borderBottom = '1px solid transparent')}
                >
                  Register as Manager
                </Link>
                or
                <Link
                  to="/register-as-staff"
                  style={{
                    textDecoration: 'none',
                    color: '#5c4b3b',
                    borderBottom: '1px solid transparent',
                    transition: 'all 0.3s ease',
                    marginLeft: '8px',
                  }}
                  onMouseEnter={(e) => (e.target.style.borderBottom = '1px solid #5c4b3b')}
                  onMouseLeave={(e) => (e.target.style.borderBottom = '1px solid transparent')}
                >
                  Staff
                </Link>
              </div>
            </div>




          </div>

        </div>
      </div>
    </div>
  );
};

export default Login;
